module.exports = __webpack_public_path__ + "static/media/img2.ef25feff.jpg";